import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { Link } from "react-router-dom";
import Api from '../../services/api';
import { toast } from "react-toastify";
import withRouter from "../../services/withRouter";
import parse from 'html-react-parser';
import Select from 'react-select'

class EligibilitySchemes extends React.Component {
    
    componentDidMount = async () => {
        window.scrollTo(0, 0);
        this.getSchemes();
    };


    constructor(props) {
        super(props);
        this.state = {
            'state_schemes' : [],
            'central_schemes' : [],
            'data' : {},
            'section': 0
        };
    }


    getSchemes = async()=>{
        var data = await this.props.location.state;
        console.log(data);
        var response = await Api.PostRequest(data, 'check-eligibility');
        if(response.status == 200){
            this.setState({'state_schemes' : response.state_schemes, 'central_schemes' : response.central_schemes})
        }
        else{

        }
    }




    
    render(){

        return(
            <>
                <div class="m-0 shadow"  style={{'width' : '100vw!important', 'maxWidth' : '100vw!important'}}>
                    <div class="row mx-0">
                        <div class="col-lg-12">
                            <div class="commn_banner_page" style={{'position' : 'relative'}}>
                                <img src="/assets/img/header_banner.png"/>
                                <h2 className="text-center mb-0" style={{'position' : 'absolute', 'top' : '40%', 'left' : '10%', 'color' : '#000000'}}>Schemes</h2>
                            </div>
                        </div>
                    </div>
                </div>

                <section id="trending_causes_main">
                    {this.state.section == 0 &&
                        <div class="mx-2">
                            <div class="row justify-content-center" id="counter">                              
                                <a href="javascript:;" onClick={()=>{this.setState({'section' : 1})}} className="col-lg-3 col-md-3 col-sm-12 col-12 my-5">
                                    <div className="about_top_boxed bg_three">
                                        <div className="about_top_boxed_icon">
                                            <img src="/assets/img/home-icons/central_scheme.png" style={{borderRadius : 0 ,'width' : '75px', 'height' : '75px'}} alt="img" />
                                        </div>
                                        <div className="about_top_boxed_text py-5">
                                            <h3>{this.state.central_schemes.length}</h3>
                                            <h4 className="justify-content-center d-flex align-items-center" style={{'color' : '#000000', 'height' : '100px'}}>Central Schemes</h4>
                                            <a href="javascript:;">More details...</a>
                                        </div>
                                        <div className="about_top_boxed_vector">
                                            <img src="/assets/img/icon/round.png" alt="img" />
                                        </div>
                                    </div>
                                </a>
                                <a href="javascript:;" onClick={()=>{this.setState({'section' : 2})}} className="col-lg-3 col-md-3 col-sm-12 col-12 my-5">
                                    <div className="about_top_boxed bg_four">
                                        <div className="about_top_boxed_icon">
                                            <img src="/assets/img/home-icons/state_scheme.png" style={{borderRadius : 0 ,'width' : '75px', 'height' : '75px'}} alt="img" />
                                        </div>
                                        <div className="about_top_boxed_text py-5">
                                            <h3 style={{"height": "43px"}}>{this.state.state_schemes.length}</h3>
                                            <h4 className="justify-content-center d-flex align-items-center" style={{'color' : '#000000', 'height' : '100px'}}>State Schemes</h4>
                                            <a href="javascript:;">More details...</a>
                                        </div>
                                        <div className="about_top_boxed_vector">
                                            <img src="/assets/img/icon/round.png" alt="img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    }
                    {this.state.section == 1 &&
                        <div class="mx-2 my-2">
                           <div class="row" id="counter">
                            <div className="col-2"></div>
                            <div class="col-lg-8">                                
                                <div class="w-100 justify-content-between d-flex align-items-center">
                                    <h6 className="text-start my-0">We found {this.state.central_schemes.length} schemes based on your preferences</h6>
                                    <button class="btn btn_theme btn_md" type="button" onClick={()=>{this.setState({'section' : 0})}}>Back</button>
                                </div>

                                
                                {this.state.central_schemes.map((scheme)=>{
                                    return(
                                        <Link to={`/scheme/${scheme.id}`} className="card my-5 shadow">
                                            <div class="causes_boxed_text" style={{'textAlign' : 'left', 'color' : '#000000'}}>
                                                <h4 style={{'textAlign' : 'left', 'color' : '#000000'}}>
                                                    <Link to={`/scheme/${scheme.id}`} style={{'textAlign' : 'left', 'color' : '#000000'}}>{scheme.title}</Link>
                                                </h4>
                                                <label className="my-3" style={{'color' : 'grey'}}>{scheme.state}</label>

                                                <div style={{'height' : '55px', color:'#000000', 'textOverflow' : 'ellipsis', 'overflow' : 'hidden'}}>{parse(scheme.description)}</div>
                                            </div>
                                        </Link>
                                    )
                                })}
                            </div>
                            <div className="col-2"></div>
                        </div>
                        </div>
                    }
                    {this.state.section == 2 &&
                        <div class="mx-2 my-2">
                           <div class="row" id="counter">
                            <div className="col-2"></div>
                            <div class="col-lg-8">                                
                                <div class="w-100 justify-content-between d-flex align-items-center">
                                    <h6 className="text-start my-0">We found {this.state.state_schemes.length} schemes based on your preferences</h6>
                                    <button class="btn btn_theme btn_md" type="button" onClick={()=>{this.setState({'section' : 0})}}>Back</button>
                                </div>

                                
                                {this.state.state_schemes.map((scheme)=>{
                                    return(
                                        <Link to={`/scheme/${scheme.id}`} className="card my-5 shadow">
                                            <div class="causes_boxed_text" style={{'textAlign' : 'left', 'color' : '#000000'}}>
                                                <h4 style={{'textAlign' : 'left', 'color' : '#000000'}}>
                                                    <Link to={`/scheme/${scheme.id}`} style={{'textAlign' : 'left', 'color' : '#000000'}}>{scheme.title}</Link>
                                                </h4>
                                                <label className="my-3" style={{'color' : 'grey'}}>{scheme.state}</label>

                                                <div style={{'height' : '55px', color:'#000000', 'textOverflow' : 'ellipsis', 'overflow' : 'hidden'}}>{parse(scheme.description)}</div>
                                            </div>
                                        </Link>
                                    )
                                })}
                            </div>
                            <div className="col-2"></div>
                        </div>
                        </div>
                    }
                    
                </section>
            </>
        )
    }
}


export default withRouter(EligibilitySchemes)